
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"ic_for here","xmlns":"http://www.w3.org/2000/svg","width":"19","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.783 9.897c.016-.229.032-.459.065-.69a12.354 12.354 0 01.333-1.638c.083-.268.173-.532.268-.791l.357-.748a6.38 6.38 0 01.922-1.3l.251-.284c.094-.084.188-.165.278-.246a6.759 6.759 0 01.547-.443 7.365 7.365 0 011.058-.637 6.505 6.505 0 01.868-.387c.5-.179.783-.27.783-.27s-.242.171-.665.449c-.218.127-.45.328-.725.533a10.516 10.516 0 00-.857.747c-.155.138-.275.311-.421.47q-.107.122-.219.246c-.061.092-.124.183-.188.277a7.526 7.526 0 00-.69 1.214l-.266.683a25.2 25.2 0 01-.2.723 11.766 11.766 0 00-.269 1.521c-.033.189-.049.379-.068.57h13.232c.017-.2.026-.395.026-.594a7.569 7.569 0 00-7.04-7.283 1.112 1.112 0 00.418-.853 1.32 1.32 0 00-2.623 0 1.109 1.109 0 00.418.853 7.568 7.568 0 00-7.038 7.283c0 .2.008.4.025.591z","fill":"inherit"}}),_c('rect',{attrs:{"width":"18.536","height":"1.238","rx":".619","transform":"translate(0 10.349)","fill":"inherit"}})])
          )
        }
      }
    